import { useNetInfo } from '@react-native-community/netinfo';

/**
 * Whether the device is known to be offline.
 *
 * NetInfo reports `null` for both flags until it has probed the network - and
 * it goes back to `null` on every connectivity change while the reachability
 * check runs again. Treating that unknown state as "offline" made the app
 * claim there was no internet on a perfectly working connection, so only a
 * definite `false` counts as disconnected.
 */
export const useIsConnected = (): boolean => {
  const netInfo = useNetInfo();
  return netInfo.isConnected !== false && netInfo.isInternetReachable !== false;
};
